import React from 'react';

import {
  MAINTENANCE_NOTICE,
  RELEASE_NOTES,
  SERVICE_ISSUE,
  PLANNED_MAINTENANCE,
  BACK_TO_NORMAL,
  BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE,
  SYSTEM_MESSAGE,
  TYPE_RELEASE_NOTES,
  TYPE_SERVICE_ISSUE,
  TYPE_PLANNED_MAINTENANCE,
  TYPE_BACK_TO_NORMAL,
  TYPE_BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE,
  TYPE_SYSTEM_MESSAGE,
} from 'App/components/News/constants';

import {
  LegacySwitchView,
  AssignmentIcon,
  AssignmentLateIcon,
  AssignmentReturnedIcon,
  AssignmentTurnedInIcon,
  AnnouncementIcon,
} from '@gogame/components';

import Preview from './Preview';

export default ({ data }) => {
  const { type, text, date } = data;

  return (
    <LegacySwitchView activeId={type}>
      <LegacySwitchView.Fragment viewId={TYPE_RELEASE_NOTES}>
        <Preview
          text={text}
          date={date}
          dateTemplate={'LL'}
          title={RELEASE_NOTES}
          icon={<AssignmentIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.Fragment viewId={TYPE_SERVICE_ISSUE}>
        <Preview
          text={text}
          date={date}
          title={`${MAINTENANCE_NOTICE} - ${SERVICE_ISSUE}`}
          icon={<AssignmentLateIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.Fragment viewId={TYPE_PLANNED_MAINTENANCE}>
        <Preview
          text={text}
          date={date}
          title={`${MAINTENANCE_NOTICE} - ${PLANNED_MAINTENANCE}`}
          icon={<AssignmentReturnedIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.Fragment viewId={TYPE_BACK_TO_NORMAL}>
        <Preview
          text={text}
          date={date}
          title={`${MAINTENANCE_NOTICE} - ${BACK_TO_NORMAL}`}
          icon={<AssignmentTurnedInIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.Fragment
        viewId={TYPE_BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE}
      >
        <Preview
          text={text}
          date={date}
          title={`${MAINTENANCE_NOTICE} - ${BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE}`}
          icon={<AssignmentTurnedInIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.Fragment viewId={TYPE_SYSTEM_MESSAGE}>
        <Preview
          text={text}
          date={date}
          title={`${MAINTENANCE_NOTICE} - ${SYSTEM_MESSAGE}`}
          icon={<AnnouncementIcon />}
        />
      </LegacySwitchView.Fragment>

      <LegacySwitchView.DefaultFragment>
        <Preview
          text={text}
          date={date}
          dateTemplate={'LL'}
          title={RELEASE_NOTES}
          icon={<AssignmentIcon />}
        />
      </LegacySwitchView.DefaultFragment>
    </LegacySwitchView>
  );
};
